import { StateCreator } from 'zustand'
import RedemptionService from 'service/RedemptionService'
import { ErrorDetails } from 'store/error/types'
import { TypesRoutes } from 'routes/mixedRoutes/types'
import { errorHandling, redirectRoute } from 'store/utils/provider'
import { defaultError } from 'common/mocks/ResponseError'
import BaseBridge from 'config/bridge/BaseBridge'

import { IRedemptionResponse, RedemptionState } from './types'

export const createRedemptionSlice: StateCreator<RedemptionState, [], [], RedemptionState> = (
  set,
) => ({
  redemptionResponse: {} as IRedemptionResponse,
  redeemValue: async (payload) => {
    try {
      const response = await RedemptionService.redeemValue()
      set({ redemptionResponse: response })
      redirectRoute(payload)
    } catch (error) {
      const errorDetails: ErrorDetails = {
        ...defaultError,
        route: TypesRoutes.REQUEST_GO_BACK,
      }

      errorHandling(error as Error, 'RedemptionService/redeemValue', errorDetails)
    }
  },
  repurchase: async (payload) => {
    try {
      const iSafeRequest = {
        category: '16',
        checkType: '5',
        feature: 'AUTORIZACAO_SEGURO',
        value: 0,
      }

      await BaseBridge.requestISafe(iSafeRequest)

      const response = await RedemptionService.repurchase(payload)
      set({ redemptionResponse: response })

      redirectRoute(payload)
    } catch (error) {
      const errorDetails: ErrorDetails = {
        ...defaultError,
        route: TypesRoutes.REQUEST_GO_BACK,
      }

      errorHandling(error as Error, 'RedemptionService/repurchase', errorDetails)
    }
  },
})
